import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var WalkerBase = /*#__PURE__*/function () {
  function WalkerBase() {
    _classCallCheck(this, WalkerBase);

    WalkerBase.prototype.__init.call(this);

    WalkerBase.prototype.__init2.call(this);

    WalkerBase.prototype.__init3.call(this);

    WalkerBase.prototype.__init4.call(this);
  }

  _createClass(WalkerBase, [{
    key: "__init",
    value: function __init() {
      this.should_skip = false;
    }
  }, {
    key: "__init2",
    value: function __init2() {
      this.should_remove = false;
    }
  }, {
    key: "__init3",
    value: function __init3() {
      this.replacement = null;
    }
  }, {
    key: "__init4",
    value: function __init4() {
      var _this = this;

      this.context = {
        skip: function skip() {
          return _this.should_skip = true;
        },
        remove: function remove() {
          return _this.should_remove = true;
        },
        replace: function replace(node) {
          return _this.replacement = node;
        }
      };
    }
  }, {
    key: "replace",
    value: function replace(parent, prop, index, node) {
      if (parent) {
        if (index !== null) {
          parent[prop][index] = node;
        } else {
          parent[prop] = node;
        }
      }
    }
  }, {
    key: "remove",
    value: function remove(parent, prop, index) {
      if (parent) {
        if (index !== null) {
          parent[prop].splice(index, 1);
        } else {
          delete parent[prop];
        }
      }
    }
  }]);

  return WalkerBase;
}();

var SyncWalkerClass = /*#__PURE__*/function (_WalkerBase) {
  _inherits(SyncWalkerClass, _WalkerBase);

  var _super = _createSuper(SyncWalkerClass);

  function SyncWalkerClass(walker) {
    var _this2;

    _classCallCheck(this, SyncWalkerClass);

    _this2 = _super.call(this);
    _this2.enter = walker.enter;
    _this2.leave = walker.leave;
    return _this2;
  }

  _createClass(SyncWalkerClass, [{
    key: "visit",
    value: function visit(node, parent, enter, leave, prop, index) {
      if (node) {
        if (enter) {
          var _should_skip = this.should_skip;
          var _should_remove = this.should_remove;
          var _replacement = this.replacement;
          this.should_skip = false;
          this.should_remove = false;
          this.replacement = null;
          enter.call(this.context, node, parent, prop, index);

          if (this.replacement) {
            node = this.replacement;
            this.replace(parent, prop, index, node);
          }

          if (this.should_remove) {
            this.remove(parent, prop, index);
          }

          var skipped = this.should_skip;
          var removed = this.should_remove;
          this.should_skip = _should_skip;
          this.should_remove = _should_remove;
          this.replacement = _replacement;
          if (skipped) return node;
          if (removed) return null;
        }

        for (var key in node) {
          var value = node[key];

          if (_typeof(value) !== "object") {
            continue;
          } else if (Array.isArray(value)) {
            for (var i = 0; i < value.length; i += 1) {
              if (value[i] !== null && typeof value[i].type === 'string') {
                if (!this.visit(value[i], node, enter, leave, key, i)) {
                  // removed
                  i--;
                }
              }
            }
          } else if (value !== null && typeof value.type === "string") {
            this.visit(value, node, enter, leave, key, null);
          }
        }

        if (leave) {
          var _replacement2 = this.replacement;
          var _should_remove2 = this.should_remove;
          this.replacement = null;
          this.should_remove = false;
          leave.call(this.context, node, parent, prop, index);

          if (this.replacement) {
            node = this.replacement;
            this.replace(parent, prop, index, node);
          }

          if (this.should_remove) {
            this.remove(parent, prop, index);
          }

          var _removed = this.should_remove;
          this.replacement = _replacement2;
          this.should_remove = _should_remove2;
          if (_removed) return null;
        }
      }

      return node;
    }
  }]);

  return SyncWalkerClass;
}(WalkerBase);

var AsyncWalkerClass = /*#__PURE__*/function (_WalkerBase2) {
  _inherits(AsyncWalkerClass, _WalkerBase2);

  var _super2 = _createSuper(AsyncWalkerClass);

  function AsyncWalkerClass(walker) {
    var _this3;

    _classCallCheck(this, AsyncWalkerClass);

    _this3 = _super2.call(this);
    _this3.enter = walker.enter;
    _this3.leave = walker.leave;
    return _this3;
  }

  _createClass(AsyncWalkerClass, [{
    key: "visit",
    value: function () {
      var _visit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(node, parent, enter, leave, prop, index) {
        var _should_skip, _should_remove, _replacement, skipped, removed, key, value, i, _replacement3, _should_remove3, _removed2;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!node) {
                  _context.next = 61;
                  break;
                }

                if (!enter) {
                  _context.next = 21;
                  break;
                }

                _should_skip = this.should_skip;
                _should_remove = this.should_remove;
                _replacement = this.replacement;
                this.should_skip = false;
                this.should_remove = false;
                this.replacement = null;
                _context.next = 10;
                return enter.call(this.context, node, parent, prop, index);

              case 10:
                if (this.replacement) {
                  node = this.replacement;
                  this.replace(parent, prop, index, node);
                }

                if (this.should_remove) {
                  this.remove(parent, prop, index);
                }

                skipped = this.should_skip;
                removed = this.should_remove;
                this.should_skip = _should_skip;
                this.should_remove = _should_remove;
                this.replacement = _replacement;

                if (!skipped) {
                  _context.next = 19;
                  break;
                }

                return _context.abrupt("return", node);

              case 19:
                if (!removed) {
                  _context.next = 21;
                  break;
                }

                return _context.abrupt("return", null);

              case 21:
                _context.t0 = _regeneratorRuntime.keys(node);

              case 22:
                if ((_context.t1 = _context.t0()).done) {
                  _context.next = 47;
                  break;
                }

                key = _context.t1.value;
                value = node[key];

                if (!(_typeof(value) !== "object")) {
                  _context.next = 29;
                  break;
                }

                return _context.abrupt("continue", 22);

              case 29:
                if (!Array.isArray(value)) {
                  _context.next = 42;
                  break;
                }

                i = 0;

              case 31:
                if (!(i < value.length)) {
                  _context.next = 40;
                  break;
                }

                if (!(value[i] !== null && typeof value[i].type === 'string')) {
                  _context.next = 37;
                  break;
                }

                _context.next = 35;
                return this.visit(value[i], node, enter, leave, key, i);

              case 35:
                if (_context.sent) {
                  _context.next = 37;
                  break;
                }

                // removed
                i--;

              case 37:
                i += 1;
                _context.next = 31;
                break;

              case 40:
                _context.next = 45;
                break;

              case 42:
                if (!(value !== null && typeof value.type === "string")) {
                  _context.next = 45;
                  break;
                }

                _context.next = 45;
                return this.visit(value, node, enter, leave, key, null);

              case 45:
                _context.next = 22;
                break;

              case 47:
                if (!leave) {
                  _context.next = 61;
                  break;
                }

                _replacement3 = this.replacement;
                _should_remove3 = this.should_remove;
                this.replacement = null;
                this.should_remove = false;
                _context.next = 54;
                return leave.call(this.context, node, parent, prop, index);

              case 54:
                if (this.replacement) {
                  node = this.replacement;
                  this.replace(parent, prop, index, node);
                }

                if (this.should_remove) {
                  this.remove(parent, prop, index);
                }

                _removed2 = this.should_remove;
                this.replacement = _replacement3;
                this.should_remove = _should_remove3;

                if (!_removed2) {
                  _context.next = 61;
                  break;
                }

                return _context.abrupt("return", null);

              case 61:
                return _context.abrupt("return", node);

              case 62:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function visit(_x, _x2, _x3, _x4, _x5, _x6) {
        return _visit.apply(this, arguments);
      }

      return visit;
    }()
  }]);

  return AsyncWalkerClass;
}(WalkerBase);

function walk(ast, walker) {
  var instance = new SyncWalkerClass(walker);
  return instance.visit(ast, null, walker.enter, walker.leave);
}

function asyncWalk(_x7, _x8) {
  return _asyncWalk.apply(this, arguments);
}

function _asyncWalk() {
  _asyncWalk = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(ast, walker) {
    var instance;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            instance = new AsyncWalkerClass(walker);
            _context2.next = 3;
            return instance.visit(ast, null, walker.enter, walker.leave);

          case 3:
            return _context2.abrupt("return", _context2.sent);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _asyncWalk.apply(this, arguments);
}

export { walk, asyncWalk };